import { useEffect, useState } from "react"

// Returns a `Date` that re-renders subscribers every
// `intervalMs`. Used by components that display
// relative-time labels ("12m", "1h", "2d") so the labels
// keep advancing as wall-clock time passes, even when no
// other prop has changed.
//
// Default cadence is one minute, which matches the
// minute-resolution of `relativeTimeLabel`. The
// `intervalMs` argument is accepted for callers that
// need a different tick rate.
export function useNow(intervalMs: number = 60_000): Date {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const handle = window.setInterval(
      () => setNow(new Date()),
      intervalMs,
    )
    return () => window.clearInterval(handle)
  }, [intervalMs])

  return now
}
